import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { storeList, storeReview, storeHandle } from '@/api/apis';
import upload from '@/plugin/upload';
export default {
  name: 'storeManager',
  data: function data() {
    return {
      loading: false,
      searchNumber: '',
      searchLicenseName: '',
      searchStatus: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 审核弹窗
      reviewDialogVisible: false,
      reviewLoading: false,
      currentRow: {},
      reviewForm: {
        status: 1,
        remark: ''
      },
      reviewRules: {
        status: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }]
      },
      // 编辑弹窗
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: '',
        number: '',
        license_name: '',
        license_legal_person: '',
        license_credit_code: '',
        license_company_type: '',
        license_registered_capital: '',
        license_valid_period: '',
        license_business_address: '',
        license_img: ''
      },
      editRules: {
        license_name: [{
          required: true,
          message: '请输入执照名称',
          trigger: 'blur'
        }],
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }]
      },
      // 店铺编号弹窗
      numberDialogVisible: false,
      // 营业执照预览
      licenseDialogVisible: false,
      licensePreviewUrl: ''
    };
  },
  computed: {
    filteredData: function filteredData() {
      var _this = this;

      var result = this.tableData;

      if (this.searchNumber) {
        result = result.filter(function (item) {
          return item.number && item.number.includes(_this.searchNumber);
        });
      }

      if (this.searchLicenseName) {
        result = result.filter(function (item) {
          return item.license_name && item.license_name.includes(_this.searchLicenseName);
        });
      }

      if (this.searchStatus !== '' && this.searchStatus !== null) {
        result = result.filter(function (item) {
          return item.status === _this.searchStatus;
        });
      }

      return result;
    },
    pagedData: function pagedData() {
      return this.filteredData;
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    // 加载店铺申请列表
    loadData: function loadData() {
      var _this2 = this;

      this.loading = true;
      storeList({
        page: this.currentPage,
        limit: this.pageSize,
        number: this.searchNumber,
        license_name: this.searchLicenseName,
        status: this.searchStatus
      }).then(function (res) {
        var data = res && res.data ? res.data : res;
        _this2.tableData = data && data.rows || [];
        _this2.total = data && data.count || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.tableData = [];
        _this2.total = 0;
        _this2.loading = false;
      });
    },
    // 搜索
    onSearch: function onSearch() {
      this.currentPage = 1;
      this.loadData();
    },
    onReset: function onReset() {
      this.searchNumber = '';
      this.searchLicenseName = '';
      this.searchStatus = '';
      this.currentPage = 1;
      this.loadData();
    },
    onSizeChange: function onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 状态文本
    statusText: function statusText(status) {
      var map = {
        0: '待审核',
        1: '已通过',
        '-1': '已拒绝'
      };
      return map[status] || '未知';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        0: 'info',
        1: 'success',
        '-1': 'danger'
      };
      return map[status] || 'info';
    },
    // 显示审核弹窗
    showReviewDialog: function showReviewDialog(row) {
      var _this3 = this;

      this.currentRow = row;
      this.reviewForm = {
        status: 1,
        remark: ''
      };
      this.reviewDialogVisible = true;
      this.$nextTick(function () {
        if (_this3.$refs.reviewForm) {
          _this3.$refs.reviewForm.clearValidate();
        }
      });
    },
    // 显示添加弹窗
    showAddDialog: function showAddDialog() {
      var _this4 = this;

      this.editForm = {
        id: '',
        number: '',
        license_name: '',
        license_legal_person: '',
        license_credit_code: '',
        license_company_type: '',
        license_registered_capital: '',
        license_valid_period: '',
        license_business_address: '',
        license_img: ''
      };
      this.editDialogVisible = true;
      this.$nextTick(function () {
        if (_this4.$refs.editForm) {
          _this4.$refs.editForm.clearValidate();
        }
      });
    },
    // 显示编辑弹窗
    showEditDialog: function showEditDialog(row) {
      var _this5 = this;

      this.editForm = {
        id: row.id,
        license_name: row.license_name || '',
        license_legal_person: row.license_legal_person || '',
        license_credit_code: row.license_credit_code || '',
        license_company_type: row.license_company_type || '',
        license_registered_capital: row.license_registered_capital || '',
        license_valid_period: row.license_valid_period || '',
        license_business_address: row.license_business_address || '',
        license_img: row.license_img || ''
      };
      this.editDialogVisible = true;
      this.$nextTick(function () {
        if (_this5.$refs.editForm) {
          _this5.$refs.editForm.clearValidate();
        }
      });
    },
    // 提交编辑
    onEditSubmit: function onEditSubmit() {
      var _this6 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this6.editLoading = true;

        var data = _objectSpread({}, _this6.editForm);

        storeHandle(data).then(function (res) {
          _this6.$message({
            message: _this6.editForm.id ? '编辑成功' : '添加成功',
            type: 'success'
          });

          _this6.editDialogVisible = false;
          _this6.editLoading = false;

          _this6.loadData();
        }).catch(function () {
          _this6.editLoading = false;
        });
      });
    },
    // 提交审核
    onReviewSubmit: function onReviewSubmit() {
      var _this7 = this;

      this.$refs.reviewForm.validate(function (valid) {
        if (!valid) return;
        _this7.reviewLoading = true;
        var data = {
          id: _this7.currentRow.id,
          status: _this7.reviewForm.status,
          remark: _this7.reviewForm.remark
        }; // TODO: 替换为真实接口

        storeReview(data).then(function (res) {
          var msg = '审核完成';
          if (_this7.reviewForm.status === 1) msg = '审核通过';else if (_this7.reviewForm.status === -1) msg = '已拒绝申请';

          _this7.$message({
            message: msg,
            type: 'success'
          });

          _this7.reviewDialogVisible = false;
          _this7.reviewLoading = false;

          _this7.loadData();
        }).catch(function () {
          _this7.reviewLoading = false;
        });
      });
    },
    // 营业执照上传前校验
    onBeforeLicenseUpload: function onBeforeLicenseUpload(file) {
      var isImage = file.type.startsWith('image/');

      if (!isImage) {
        this.$message.error('只能上传图片文件');
      }

      return isImage;
    },
    // 营业执照上传
    onUploadLicense: function onUploadLicense(option) {
      upload.upload(option, {
        type: 'license'
      });
    },
    // 营业执照上传成功
    onLicenseUploadSuccess: function onLicenseUploadSuccess(response) {
      if (response && response.url) {
        this.$set(this.editForm, 'license_img', response.url);
      }
    },
    // 预览营业执照
    previewLicense: function previewLicense(row) {
      this.licensePreviewUrl = row.license_img;
      this.licenseDialogVisible = true;
    },
    // 显示店铺编号
    showStoreNumber: function showStoreNumber(row) {
      this.currentRow = row;
      this.numberDialogVisible = true;
    },
    // 复制店铺编号
    copyStoreNumber: function copyStoreNumber(number) {
      var aux = document.createElement('input');
      aux.setAttribute('value', number);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand('copy');
      document.body.removeChild(aux);
      this.$message({
        message: '已复制到剪贴板',
        type: 'success'
      });
    }
  }
};